const AccoladesData = [
    {
        main: "400+",
        sub1: "Projects completed",
        sub2: "We’ve helped build over 400 projects with great companies."
    },
    {
        main: "600%",
        sub1: "Return on investment",
        sub2: "We’ve helped build over 400 projects with great companies."
    },
    {
        main: "10k",
        sub1: "Global downloads",
        sub2: "Our free UI kit has been downloaded over 10k times."
    }
]
export default AccoladesData